import HTTP from 'http';
import URL from 'url';
import path from 'path';

const httpRequest = (config) => (method, reqURL, body = '', headers = null, appConfig = null) => {
  const BACKEND_URL = config.API_ROOT_URL || (appConfig && appConfig.API_ROOT_URL) || "";
  if (typeof method !== 'string') throw new TypeError('method is required');
  if (typeof reqURL !== 'string') throw new TypeError('URL is required');
  const url = reqURL.match(/^http/) || reqURL.includes(BACKEND_URL) ? reqURL : BACKEND_URL + reqURL;
  const options = {method, ...URL.parse(url), withCredentials: false};
  const data = typeof body === 'string' ? body : JSON.stringify(body);
  if (!headers) {
    if (method.match(/GET|HEAD|DELETE/)) {
      options.headers = { 'Accept': 'application/json' };
    } else if (method.match(/POST|PUT|PATCH/)) {
      if (!body) throw new TypeError('data is required');
      // if (typeof data !== 'string') throw new TypeError('data is required');
      options.headers = {
        'Content-Type': 'application/json',
        'Content-Length': data.length,
      };
    }
  } else {
    if (typeof headers !== 'object') {
      throw new TypeError('headers must be an object');
    }
    options.headers = headers || {};
  }
  const localData = localStorage.getItem('currentUser') || '{}';
  const jwt = JSON.parse(localData).jwt;
  if (jwt) {
    options.headers.Authorization = `Bearer ${jwt}`;
  }
  return new Promise((resolve, reject) => {
    const req = HTTP.request(options, res => {
      let stringData = '';
      res.on('data', chunk => {
        stringData += chunk;
      });
      res.on('end', () => {
        let result;
        try {
          result = stringData && stringData !== ''
            ? JSON.parse(stringData)
            : null;
        } catch (e) {
          result = null;
        }
        if (res.statusCode < 200 || res.statusCode > 299) {
          const err = result ? result.error : 'Sorry, an error occurred while trying to connect to the backend.';
          return reject(err);
        }
        resolve(result);
      });
    });
    if (data && method.match(/POST|PUT|PATCH|DELETE/)) {
      req.write(data);
    }
    req.on('error', err => reject(err.message));
    req.end();
  });
}

export default httpRequest;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/helpers/httpRequest.js